import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@mui/material";
import { FaEdit, FaTags, FaBars } from "react-icons/fa";
import Principales from "../../pages/Obtener/ObtenerPrincipales"; // Asegúrate de que este archivo exista
import logo from "../../img/LOGO-Icontec-2019_ver_white (1).png";

const SidebarMenu = ({ open, toggleSidebar }) => {
  const drawerWidth = 240;

  return (
    <Drawer
      variant="temporary"
      open={open}
      onClose={toggleSidebar}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        backgroundColor: "#0085CA", // Azul claro
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#0085CA", // Azul claro
          display: "flex",
          flexDirection: "column", // Asegura que los elementos se apilen verticalmente
        },
      }}
    >
      <List sx={{ flex: 1 }}>
        <ListItem
          button
          onClick={() => (window.location.href = "/Principales")}
        >
          <ListItemIcon>
            <FaEdit />
          </ListItemIcon>
          <ListItemText
            primary="Gestionar Formularios"
            sx={{ color: "white" }} // Color de texto blanco
          />
        </ListItem>
      </List>

      {/* Imagen en la parte inferior del sidebar */}
      <div style={{ marginTop: "auto", padding: "10px" }}>
        <img
          src={logo} // Cambia esta URL a la imagen que quieras usar
          alt="Logo"
          style={{ width: "100%", borderRadius: "8px" }} // Ajusta el tamaño y el borde de la imagen
        />
      </div>
    </Drawer>
  );
};

const Tematicas = () => <div>Temáticas Page</div>;

const App = () => {
  const [open, setOpen] = useState(false); // Estado para controlar la apertura/cierre del sidebar

  const toggleSidebar = () => {
    setOpen(!open);
  };

  return (
    <Router>
      <div style={{ display: "flex" }}>
        {/* Botón para abrir/cerrar el sidebar */}
        <IconButton
          sx={{
            position: "absolute", // Hace que el icono esté en la parte superior izquierda
            top: 20,
            left: 20,
            color: "#0085CA",
            zIndex: 10, // Asegura que el icono esté sobre el contenido
          }}
          onClick={toggleSidebar}
        >
          <FaBars size={30} />
        </IconButton>

        {/* Sidebar */}
        <SidebarMenu open={open} toggleSidebar={toggleSidebar} />

        {/* Contenedor para las rutas */}
        <div style={{ flex: 1, padding: "20px" }}>
          <Routes>
            <Route path="/Principales" element={<Principales />} />
            <Route path="/tematicas" element={<Tematicas />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
